// extracted by mini-css-extract-plugin
export default {"inputLabel":"RoleCheckbox_inputLabel__SRylD","processingText":"RoleCheckbox_processingText__ZjE5X","input":"RoleCheckbox_input__zspAV","inputError":"RoleCheckbox_inputError__+GYHy"};